import gsap from "gsap";
import React, { useEffect } from "react";
import ScrollMagic from "scrollmagic";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import MainContainer from "../../components/MainContainer";
import { AssetWrapper } from "./styled";
import SectionMain from "./components/SectionMain";
import { assetSectionsData } from "../../data/assetSections";
import AssetSection from "./components/AssetSection";
import SectionMenu from "./components/SectionMenu";
import AssetSectionStory from "./components/SectionStory";

ScrollMagicPluginGsap(ScrollMagic, gsap);

const Asset = () => {
  useEffect(() => {
    const controller = new ScrollMagic.Controller();

    // 기존 active 클래스들을 모두 제거하는 함수
    const removeAllActive = () => {
      assetSectionsData.forEach((section) => {
        document
          .getElementById(`${section.id}-nav`)
          ?.classList.remove("active");
      });
    };

    assetSectionsData.forEach((section) => {
      new ScrollMagic.Scene({
        triggerElement: `#${section.id}`,
        duration: "100%",
      })
        .on("enter", () => {
          removeAllActive(); // 모든 active 제거
          document.getElementById(`${section.id}-nav`)?.classList.add("active"); // 현재만 활성화
        })
        .addTo(controller);
    });
  });

  return (
    <MainContainer>
      <AssetWrapper>
        <SectionMain />

        {assetSectionsData.map((sectionData, index) => (
          <AssetSection key={index} sectionData={sectionData} />
        ))}
        <AssetSectionStory />
        <SectionMenu />
      </AssetWrapper>
    </MainContainer>
  );
};

export default Asset;
